class NavTabs extends HTMLElement {
  constructor() {
    super();
    this.setActiveTab = this.setActiveTab.bind(this);
  }
  connectedCallback() {
    this.Tabs = {};
    this.tabsContainerEl = this;
    this.tabsNavEls = this.tabsContainerEl.querySelectorAll(".js-tab-nav");
    this.tabsContentEls = this.tabsContainerEl.querySelectorAll(".js-tab-content");
    this.toggleClassOnly = this.tabsContainerEl.hasAttribute("toggle-class-only") || false;
    this.tabsNavEls.forEach((tabEl) => {
      tabEl.addEventListener("click", this.setActiveTab);
    });
  }
  setActiveTab(event) {
    this.tabsNavEls.forEach((tabEl) => {
      if (tabEl.classList.contains("active")) {
        tabEl.classList.remove("active");
      }
    });
    this.tabsContentEls.forEach((tabEl) => {
      if (!this.toggleClassOnly) {
        tabEl.style.display = "none";
      }
      if (tabEl.classList.contains("active")) {
        tabEl.classList.remove("active");
      }
    });
    let activeTabNav = event.currentTarget;
    let targetTabName = activeTabNav.getAttribute("data-target");
    let activeTabContent = this.tabsContainerEl.querySelector(targetTabName);
    if (activeTabNav) {
      activeTabNav.classList.add("active");
    }
    if (activeTabContent) {
      activeTabContent.classList.add("active");
    }
    if (activeTabContent && !this.toggleClassOnly) {
      activeTabContent.style.display = "block";
    }
  }
}
customElements.define("w3-tabs", NavTabs);
